<script>

	export let qrImage = '';
	export let errmsg = '';
	export let errreason = '';
	export let qrString = '';

	// function openUPIApps() {

	// 	console.log("qrString.... ",qrString);

	// 	//Check if mobile browser
	// 	 if( navigator.userAgent.match(/Android/i)
	// 		|| navigator.userAgent.match(/webOS/i)
	// 		|| navigator.userAgent.match(/iPhone/i)
	// 		|| navigator.userAgent.match(/iPad/i)
	// 		|| navigator.userAgent.match(/iPod/i)
	// 		|| navigator.userAgent.match(/BlackBerry/i)
	// 		|| navigator.userAgent.match(/Windows Phone/i)
	// 		){
	// 		window.open(qrString);
	// 	}

	// }

</script>


<style>

	/* svg { width:100%; } */

	/* #qrimagesection {
		background-color: #fff;
	} */

	/* svg {
		background:#FFF;
		fill:green;
	} */

	:global(svg) {
		display: block;
		background: #FFF;
		border-radius:6px;
		fill:#043a04;
	}

	.center {
		text-align: center;
	}

</style>


<div id="qrimagesection">{@html qrImage}</div>


<!-- <div id="qrimagesection" on:click={openUPIApps}>{@html qrImage}</div> -->

<div class="center">

	<label>
	{errreason}
	</label>
</div>
